module.exports = __webpack_public_path__ + "img/succeed.5d6ff177.png";